import { getBaseLanguageFromLocaleCode } from '../../../translations/utils'
import { businessAreasEnGB } from '../../../translations/locales/en-GB'
import { businessAreasPtPT } from '../../../translations/locales/pt-PT'
import type { BusinessArea } from './types'

function filterBusinessAreaByName(list: BusinessArea[], text: string) {
  // The line below escapes regular expression special characters:
  // [ \ ^ $ . | ? * + ( )
  const escapedText = text.replace(/[-\\^$*+?.()|[\]{}]/g, '\\$&');

  // Create the regular expression with modified value which
  // handles escaping special characters. Without escaping special
  // characters, errors will appear in the console
  const exp = new RegExp(escapedText, 'i');
  return list.filter(o => exp.test(o));
}

export function buildBusinessAreaList(locale: string, filter: string): BusinessArea[] {

  var businessAreaList: BusinessArea[] = []

  if (getBaseLanguageFromLocaleCode(locale) === 'pt') {
    businessAreaList = businessAreasPtPT.map(area => {
      return area;
    });
  }
  else {

    businessAreaList = businessAreasEnGB.map(area => {
      return area;
    });
  }

  return filter ? filterBusinessAreaByName(businessAreaList, filter) : businessAreaList

}

